<template>
    <div class="renewal-edit-manage">
        <Paper class="renewal-edit-manage-paper">
            <list-layout-paper>
                <template slot="header-search" class="searchBox">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        :showResetBtn="true"
                        @search-change="renewalList.searchList"
                    />
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <edit-table-box
                        ref="editTableBox"
                        v-loading="renewalList.tableLoading"
                        :index="config.index"
                        :selection="config.selection"
                        :columns="config.columns"
                        :height="tableHeight"
                        :tableData="renewalList.totalData"
                        :actions="config.actions || []"
                        :rowEdit="config.rowEdit"
                        :allowRowClick="!config.getAuthRole()"
                        :allowRowClickFunc="(row) => config.rowEnableEditFun(row)"
                        :editDisableRule="(row) => !config.rowEnableEditFun(row)"
                        @btn-event="handleActive"
                        @element-change="handleChangeRow"
                    >
                    </edit-table-box>
                    <!-- <table-box class="prescreen" v-loading="renewalList.tableLoading" :selection="config.selection"
                        :control="false" :columns="config.columns" :height="config.height"
                        :tableData="renewalList.totalData" :actions="config.actions"
                        :allowRowClick="false" :rows="renewalList.totalData" @action-click="handleActive">
                    </table-box> -->
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="renewalList.sizeChange"
                        :current-page.sync="renewalList.pageNo"
                        @current-change="renewalList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="renewalList.pageTotal" >
                    </lots-pagination>
                </template>
            </list-layout-paper>
        </Paper>
    </div>
</template>

<script>
import { reactive, onMounted, onActivated } from '@vue/composition-api';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { tableConfig } from './config.js';
// import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import editTableBox from '@/components/lots/editTableBox/Index';
import Paper from '@/components/core/Paper';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import _ from 'lodash';
import {
    getToDoPage,
    updateToDo
} from '@mdm/api/pendingManage/renewalPending.js';
import { Message } from 'element-ui';

export default {
    name: 'renewalPending',
    components: {
        lotsPagination,
        // tableBox,
        editTableBox,
        Paper,
        listLayoutPaper,
        searchBox
        // lotsButton
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(_.cloneDeep(tableConfig));
        class OverseasListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    renewalList.pageTotal.value = res.data.totalCount;
                    renewalList.totalData.value = res.data.list.map(item => ({
                        edit: -3,
                        allowEdit: true,
                        ...item
                    }));
                }
            };
        }
        const renewalList = new OverseasListClass({
            Api: {
                listApi: getToDoPage // 查询接口
            }
        });
        const searchDataFormat = (condition = {}, params = {}) => {
            if (condition.companyCodes) {
                // 选择分公司
                condition.companyCodeList = condition.companyCodes.split(',');
                Reflect.deleteProperty(condition, 'companyCodes');
                Reflect.deleteProperty(condition, 'companyNames');
            }
            Object.keys(condition).forEach(v => {
                !condition[v] && condition[v] !== 0 && (condition[v] = undefined);
            });
            return { ...condition, ...params };
        };
        const handleActive = (row, event) => {
            // 取消
            if (event === 'cancel') {
                const index = renewalList.totalData.value.findIndex(it => it.id === row.id);
                renewalList.totalData.value[index] = row.backup;
            }
            // 保存
            if (event === 'save') {
                handleSave(row);
            }
        };
        const editData = {};
        const handleChangeRow = ({ row }) => {
            editData.handlerCode = row.handlerCode;
            editData.handlerName = row.handlerName;
            editData.id = row.id;
        };
        const handleSave = (row) => {
            updateToDo(editData).then(res => {
                if (res && +res.code === 0) {
                    Message.success('修改成功');
                    renewalList.getList();
                }
            });
        };
        onActivated(() => {
            setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
        });
        onMounted(async() => {
            const queryParams = {
                // effectTime: utils.defaultDate('365')
            };
            setupContext.refs.searchBox.setQueryParams(queryParams);
            setupContext.refs.searchBox.submitSearch();
        });
        return {
            renewalList,
            config,
            handleActive,
            handleChangeRow
        };
    }
};
</script>

<style scoped lang="less">
.renewal-edit-manage {
    width: 100%;
  .renewal-edit-manage-paper {
    height: 100%;
  }
  .list-layout-wrapper {
    height: 100%;
  }

  .el-tabs {
    width: 100%;
  }
  .flex-layout .list-main {
    overflow: auto;
  }
  .flex-layout .table {
    overflow-y: auto;
  }
  .layout-content.costomer-series-manage-paper {
        padding: 0px 0px 0px;
  }
  .col-append-box {
    display: flex;
    align-items: center;
    .col-append-btn {
      padding-bottom: 3px;
      padding-left: 3px;
      .eye-btn {
        display: inline-block;
        width: 10px;
        height: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>
